module.exports = __webpack_public_path__ + "img/about.26bca542.svg";